import { useState } from 'react';
import { Box, styled, Collapse } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { SText } from '@setvi/shared/components';

export { PillTabs } from './pill-tabs';

export const StyledBox = styled(Box)({
  background: 'white',
  borderRadius: 12,
  padding: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 8
});

export const StyledBoxTitle = styled(SText)({
  marginBottom: 2
});

const CollapsibleHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  padding: '4px 0 0 0'
});

const ExpandIconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'transform 0.2s ease-in-out'
});

const CollapsibleContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8
});

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

export const CollapsibleSection = ({
  title,
  children,
  defaultExpanded = true
}: CollapsibleSectionProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <StyledBox>
      <CollapsibleHeader onClick={() => setExpanded(!expanded)}>
        <SText fontColor="#20262D" weight="semibold">
          {title}
        </SText>
        <ExpandIconWrapper
          style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <ExpandMoreIcon style={{ color: '#5D7083' }} />
        </ExpandIconWrapper>
      </CollapsibleHeader>
      <Collapse in={expanded}>
        <CollapsibleContent>{children}</CollapsibleContent>
      </Collapse>
    </StyledBox>
  );
};

export const Content = styled(Box)(({ theme }) => ({
  gap: 8,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 4),
  overflow: 'hidden auto'
}));

export const CheckboxGroup = styled(Box)({
  gap: 2,
  display: 'flex',
  flexDirection: 'column'
});

export const Footer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 4, 4, 4)
}));
